<template>
  <div class="button">
    <div class="button-div-a" @click="toAuction">
      <div>
        <img src="@/assets/imgs/personal/focus.png" />
      </div>
      <p>关注</p>
    </div>
    <div class="button-div-a" @click="toPickupApplication">
      <div>
        <img src="@/assets/imgs/personal/bill.png" />
      </div>
      <p>提货单</p>
    </div>
    <div class="button-div-a" @click="toFunds">
      <div>
        <img src="@/assets/imgs/personal/coin.png" />
      </div>
      <p>资金</p>
    </div>
    <div class="button-div-a" @click="toQualificationList">
      <div>
        <img src="@/assets/imgs/personal/qualifications.png" />
      </div>
      <p>资质</p>
    </div>
    <div class="button-div-a" @click="toCompany">
      <div>
        <img src="@/assets/imgs/personal/company.png" />
      </div>
      <p>公司</p>
    </div>
  </div>
</template>
<script>
export default {
  name: "Button",
  data() {
    return {
      number: 50,
    }
  },
  methods: {
    toAuction() {
      this.$router.push("/attention");
    },
    toCompany() {
      this.$router.push("/companyInformation");
    },
    toFunds() {
      this.$router.push("/fundInquiry");
    },
    toQualificationList() {
      this.$router.push("/qualificationList");
    },
    toPickupApplication() {
      this.$router.push("/pickupApplication");
    }
  },
};
</script>
<style lang="stylus" scoped>
.button {
  height: 178px;
  border-radius: 0.16rem;
  display: flex;
  justify-content: space-around;
  align-items: center;
  background-color: rgba(255, 255, 255, 1);

.button-div-a {
  text-align: center;
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 24px;
  color: #666666;

img {
  width: 64px;
  height: 64px;
// vertical-align: middle;
  margin-bottom: 16px;
}

p {
}
}
}
</style>
